import React from "react";
import Modal from "../../../../elements/Modal";
import ManagePublication from "../ManagePublication";

const ManagePublicationModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="xl2"
      title={data?._id ? "Update One" : "Create New"}
    >
      <ManagePublication getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManagePublicationModal;
